import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';


const MediaData = (props) => {
  const { i18n, t } = useTranslation(['consultations']);
  return (
    <React.Fragment>
      <div style={{display: "flex"}}>
        <div data-tooltip={t("selectPharmacyToolTip")} 
        >
          <i 
            className="fas fa-prescription-bottle-alt" 
            style={{ cursor: "pointer", fontSize: "20px"}} 
            onClick={props.togglePharmacyModal(props.pharmacyModalName)}
          >
          </i>
        </div>
        
        <div 
          style={{fontSize: "1.3rem"}}
        >
          <p  
          > {props.message}</p>
          <p>{ moment(props.created_at).locale(i18n.language).format('HH:mm')}</p>
        </div>
      </div>
    </React.Fragment>
  )
}

export default MediaData;